import { makeActionCreator } from '../../utils';
import { appActionTypes } from '../actionTypes';

// APP ACTION CREATORS

/**
 * Create an action creator that sets the state value of the server current locale
 * @constant
 * @type {function} updateLocale action creator
 */
export const updateLocale = makeActionCreator(appActionTypes.UPDATE_LOCALE, 'locale');

/**
 * Create an action creator that sets the name of the currently active page
 * Fired by components when a new page view is mounted
 * @constant
 * @type {function} updateCurrentPage action creator
 */
export const updateCurrentPage = makeActionCreator(appActionTypes.UPDATE_CURRENT_PAGE, 'currentPage');

/**
 * Create an action creator that sets the status of network connectivity
 * Fired by the browser when a network status change is heard
 * @constant
 * @type {function} updateNetworkStatus action creator
 */
export const updateNetworkStatus = makeActionCreator(appActionTypes.UPDATE_NETWORK_STATUS, 'online');

/**
 * Create an action creator that sets the device type being used
 * Fired by the app on enter
 * @constant
 * @type {function} updateDeviceType action creator
 */
export const updateDeviceType = makeActionCreator(appActionTypes.UPDATE_DEVICE_TYPE, 'deviceType');



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/actions/actionCreators/appActionCreators.js